<div class="beta-tool" nz-tooltip [nzTooltipTitle]="tooltipTemplate" nzTooltipPlacement="bottom" nzTooltipOverlayClassName="beta-tool-overlay">
  {{ "BETA_TOOL.LABEL" | translate }}
</div>

<ng-template #tooltipTemplate>
  <div class="beta-tool-tooltip">
    <div class="title">{{ "BETA_TOOL.TOOLTIP.TITLE" | translate }}</div>
    <div class="description">{{ "BETA_TOOL.TOOLTIP.DESCRIPTION" | translate }}</div>
  </div>
</ng-template>
